module.exports = __webpack_public_path__ + "img/pin-diamond.0ea3a168.png";